// client/src/locales/en

const en = {
  translation: {
    publication: {
      subjects: "All subjects", 
      sort: "Sort", 
      date_newest: "Sort on date (Newest)", 
      date_oldest: "Sort on date (Oldest)", 
      title_a_z: "Sort on title (A-Z)", 
      title_z_a: "Sort on title (Z-A)" ,
      nadaa: "No event planned for now.",
      search_placeholder: "Search on title or author",
      date_from: "From",
      date_to: "To",
      search_button: "Show results",
      no_results: "No publication found."
    },
    webinar: {
      subjects: "All subjects", 
      countries: "All countries",
      no_results: "No webinars found.",
      watch_this: "Watch this"
    },
    conference: {
      subjects: "All subjects", 
      countries: "All countries",
      no_results: "No conferences found.",
      read_this: "Read this"
    },
    videos: {
      subjects: "All subjects", 
      countries: "All countries",
      no_results: "No videos found.",
      read_this: "Read this"
    },
    shop: {
      order_title: "Your order", 
      order_intro: "Praesent commodo cursus magna, vel scelerisque nisl consectetur et.", 
      place_order: "Request material", 
      filter: "All subjects", 
      download: "Download", 
      prev: "Previous step",
      form: "Adress information", 
      max: "You reached the maximum allowed to order",
      aside_title: "Your order" , 
      selected_items: "items selected",
      thanks: "Thanks",
      form_submit: 'Submit form',
    },
    related_articles: {
      link: "Read this article",
      title: "These articles may be of interest to you"
    },
    form: {
      form_submit: 'Submit form',
      make_a_choice: 'Select an option',
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close',
      disclaimer: 'For healthcare professionals only', 
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List',
      },
    },
    searchbar: {
      label: 'What are you looking for?',
      placeholder: 'example: nutrients in milk',
    },
    header: {
      language: 'local institutes: ',
    },
    regionSwitch: {
      title: "FrieslandCampina, your global dairy partner",
      description: "We are a worldwide dairy cooperation, operating in more than 50 countries",
      language: "Global"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Terms & Conditions',
      },
      follow_us: 'Follow us',
    },
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description:
        "It seems like the page doesn't exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.",
      link: '/',
      homepage: 'To homepage',
    },
    cookiebar: {
      title: 'Welcome!',
      description:
        "Probably you're already familiair with companies who are settings cookies on your desktop, tablet or phone. Friesland Campina is also using cookies and you can choose which ones.",
      accept: 'Accept',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'No, decline',
      statement: 'Cookie statement',
      missing: 'You need to enable our cookies to view this video.',
      settings: "Cookie settings"
    },
    searchResults: {
      title: 'Your search',
      noSearchTerm: 'You haven\'t supplied a search term',
      types: {
        article: "Article",
        page: 'Page',
        news: 'News',
        story: 'Story',
        webinar: "Webinar",
        conference: "Conference",
        events: "Event", 
      },
      noResults: 'No results found. Try again with these tips:',
      noResultsTips: {
        spelling: 'Check your spelling',
        describe: 'Describe your search differently',
        shorter: 'Make your search shorter',
      },
    },
    filter: {
      noResults: 'There are no results found when filtering on this category. Please select a different category or click <a href="/frieslandcampina-news/">here</a> to go to the news overview.'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    },
    share_link: {
      title: 'Share on'
    },
    news: {
      categories: 'Categories:',
    },
    story: {
      categories: 'Categories:',
    },
    filters: {
      filter_on: 'Filter on:',
      category: 'Category',
      all_categories: 'All categories',
      year: 'Year',
      all_years: 'All years',
    },
    formMessage: 'Checking...',
    highlights: {
      title: 'Today at FrieslandCampina',
      footer_copy: 'Find out what else is going on at FrieslandCampina:',
      link_copy: 'Visit our newsroom',
      link_url: "/frieslandcampina-news/"
    },
    certificate:{
      download: "Click here to download your certificate",
      find_download: "You will find the certificate in the download folder"
    },
    newsletter: {
      message: 'From which local institute would you like to receive a newsletter?',
      placeholder: 'Select your local institute',
      countries: {
        asia: 'Asia',
        china: 'China',
        indonesia: "Indonesia",
        belgium_nl: 'Belgium NL',
        belgium_fr: 'Belgium FR',
        netherlands: "Netherlands",
        nigeria: 'Nigeria',
        pakistan: 'Pakistan',
        mexico: 'Mexico',
        other: 'Other countries'
      }
    }
  },
}

export default en;
